module.exports = __webpack_public_path__ + "img/settings.471869a3.svg";